/**
 * Which cards share a height on the board. Executive, division and department
 * cards are equalised with the other cards of the same type on the same ROW
 * (tree level), so a row lines up. Before Nov 2026 they were equalised per type
 * board-wide: the CEO's executive card (head + deputy) then stretched every
 * executive a row below it, leaving a tall empty band on each.
 *
 * Returns null for parts that keep their own height (sections, units, posts,
 * the hidden root).
 */
export const EQUALISED_PART_TYPES = ['executive', 'division', 'department'] as const;

export interface HeightGroupNode {
    id?: number | string;
    data?: unknown;
    _getLevel?: () => number;
}

export function orgBoardHeightGroup(node: HeightGroupNode | null | undefined): string | null {
    const partType = (node?.data as { partType?: string } | null | undefined)?.partType;
    if (!partType || !(EQUALISED_PART_TYPES as readonly string[]).includes(partType)) return null;
    let level = 0;
    try {
        const l = node?._getLevel?.();
        level = typeof l === 'number' && !isNaN(l) ? l : 0;
    } catch {
        level = 0;
    }
    return `${partType}:${level}`;
}
